import { render, staticRenderFns } from "./_Private.vue?vue&type=template&id=4b8eb3ab&scoped=true"
import script from "./_Private.vue?vue&type=script&lang=js"
export * from "./_Private.vue?vue&type=script&lang=js"
import style0 from "./_Private.vue?vue&type=style&index=0&id=4b8eb3ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8eb3ab",
  null
  
)

export default component.exports